export default __webpack_public_path__ + "static/media/rewards-loader.792753d3.gif";